import { useEffect } from 'react';
import Text from "../atoms/Text.jsx";
import styles from "./AboutDoberanSection.module.css";

/**
 * どべらんって？セクション
 * @param {object} props
 * @param {Array<string>} props.items - リスト項目の配列（"ラベル：値"形式）
 * @param {string} [props.className] - 追加クラス
 */
const AboutDoberanSection = ({ items, className = "" }) => {
  // 各項目を「ラベル」と「値」に分割
  const parseItem = (item) => {
    const parts = item.split("：");
    return {
      label: parts[0] || "",
      value: parts.slice(1).join("：") || ""
    };
  };

  useEffect(() => {
    const twitterScript = document.createElement('script');
    twitterScript.setAttribute('src', 'https://platform.twitter.com/widgets.js');
    twitterScript.setAttribute('async', 'true');
    twitterScript.setAttribute('charset', 'utf-8');
    document.head.appendChild(twitterScript);

    return () => {
      // 一度だけ読み込まれるように cleanup（必須ではないが安全）
      if (twitterScript) {
        twitterScript.remove();
      }
    };
  }, []);

  return (
    <section className={`${styles.aboutDoberanSection} ${className}`.trim()} id="about-doberan">
      <div className={styles.contentContainer}>
        <Text as="h3" className={styles.sectionTitle}>どべらんって？</Text>
        <table className={styles.infoTable}>
          <tbody>
            {items.map((item, i) => {
              const { label, value } = parseItem(item);
              return (
                <tr key={i} className={styles.tableRow}>
                  <td className={styles.labelCell}>
                    <Text as="span" className={styles.labelText}>{label}</Text>
                  </td>
                  <td className={styles.valueCell}>
                    <Text as="span" className={styles.valueText}>{value}</Text>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className={styles.twitterTimelineContainer}>
        <a class="twitter-timeline"
          href="https://x.com/doberan_games"
          data-theme="dark"
          data-height="600">
          Tweets by @doberan_games
        </a>
      </div>
    </section>
  );
};

export default AboutDoberanSection;
